export const buildUrlFromLocation = (
  origin: string,
  location: {
    pathname: string;
    search: string;
    hash: string;
  }
) => `${origin}${location.pathname}${location.search}${location.hash}`;

export const getBrowserHref = () => window.location.href;
